// Shared by the mobile contact screen: the card drops its frame and stretches to the viewport
// instead of sitting in a column.
export const FILL_HEIGHT_CARD_SX = {
    flex: 1,
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
    border: 0,
    borderRadius: 0,
} as const;

export const FILL_HEIGHT_SECTION_SX = { flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' } as const;
